import { render, staticRenderFns } from "./OneColumn.vue?vue&type=template&id=180a3656"
import script from "./OneColumn.vue?vue&type=script&lang=js"
export * from "./OneColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180a3656')) {
      api.createRecord('180a3656', component.options)
    } else {
      api.reload('180a3656', component.options)
    }
    module.hot.accept("./OneColumn.vue?vue&type=template&id=180a3656", function () {
      api.rerender('180a3656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/OneColumn.vue"
export default component.exports